import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const initialState = null as null | number;

const slice = createSlice({
  name: 'verificationResendAt',
  initialState,
  reducers: {
    setVerificationResendAt(_state, action: PayloadAction<number>) {
      return action.payload;
    },
    clearVerificationResendAt() {
      return null;
    },
  },
});

export const { setVerificationResendAt, clearVerificationResendAt } = slice.actions;

export default slice.reducer;
